import { requests } from '@/libs/axios/axios'
import { LicenseEndpoints } from '../license-endpoints'

async function getLicense() {
  return requests.get(`${LicenseEndpoints.LICENSE}/getCurrentUserLicense`)
}

export default getLicense
